<div class="mobile-container">
    <div class="logo image-container">
        <img src="/assets/images/logos/tcat-full.png" />
    </div>
    <h1>Download </h1>
    <h2>TCat App</h2>

    <div class="illustration image-container">
        <img src="/assets/images/bg/mobile-view-port.png" />
    </div>
    <p>
        We are sorry that the TCat portal is not availble in this view port. We support laptops and large screen devices. We do have 
        a mobile app specifically for travellers. Do check out on the Apple Store or Google Playstore.
    </p>
    <div class="stores">
        <a href="https://apps.apple.com/in/app/tcat-business-travel/id1527602650" target="_blank">
            <img class="apple-store" src="/assets/images/store/appstore.svg" alt="Download on the App Store">
        </a>
        <a href="https://play.google.com/store/apps/details?id=com.catalyca.trotcat.triporganizer" target="_blank">
            <img class="google-play" src ="/assets/images/store/googleplay.svg" alt="Get it on Google Play">
        </a>
    </div>
</div>